export default __webpack_public_path__ + "static/media/icon_cat_DiamondWeddingBands.501982d7.png";